import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            菲菲影院为什么是追剧首选平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 text-center border border-background-200/70 hover:border-primary-200 transition-colors"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-50 flex items-center justify-center mx-auto mb-4">
                <i className={`${item.icon} text-primary-500 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}